import { DndContext, DragEndEvent, closestCenter } from "@dnd-kit/core"
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable"
import { Grid, Typography } from "@mui/material"
import { useEffect } from "react"
import { useGamesAPI, useGamesData } from "../../context/GamesProvider"
import { useSortGameReducer } from "./SortGameReducer"

export const SortGameModule = () => {
  console.log("sortGameModule render")

  //  CONTEXTS
  const { validateGame, setProgress } = useGamesAPI()
  const { current } = useGamesData()

  //  LOGIC
  const { dispatch, sortables, items, data } = useSortGameReducer({
    current,
  })

  //  EVENTS
  useEffect(() => {
    if (data.isValid) validateGame()
  }, [data.isValid, validateGame])

  useEffect(() => {
    setProgress(data.progress ?? 0)
  }, [data.progress, setProgress])

  //  HANDLES
  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (over && active.id !== over.id) {
      dispatch({
        type: "switch",
        overId: over.id as string,
        activeId: active.id as string,
      })
    }
  }

  return (
    <Grid item container xs={10} pb={10}>
      <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <Grid item container justifyContent="center" spacing={6}>
          <Grid item >
            {sortables.map((_, i) => (
              <Grid
                key={`number${i}`}
                item
                container
                sx={{
                  height: "85px",
                  m: "16px",
                  bgcolor: "secondary.main",
                  color: "secondary.contrastText",
                  borderRadius: "10px",
                  minWidth: "40px",
                }}
                alignItems="center"
                justifyContent="center"
              >
                <Typography>{i + 1}</Typography>
              </Grid>
            ))}
          </Grid>
          <Grid item xs={8}>
            <SortableContext
              strategy={verticalListSortingStrategy}
              items={items}
            >
              {sortables}
            </SortableContext>
          </Grid>
        </Grid>
      </DndContext>
    </Grid>
  )
}
